import { render, staticRenderFns } from "./bindCS.vue?vue&type=template&id=479a6a52&scoped=true"
import script from "./bindCS.vue?vue&type=script&lang=js"
export * from "./bindCS.vue?vue&type=script&lang=js"
import style0 from "./bindCS.vue?vue&type=style&index=0&id=479a6a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a6a52",
  null
  
)

export default component.exports